export class ActivityDetail {
  public clubId: number;
  public clubName: string;
  public companyId: number;
  public companyName: string;
  public activityId: number;
  public title: string;
  public districtId: number;
  public districtName: string;
  public visionCount: number;
  public hungerCount: number;
  public environmentCount: number;
  public diabetesCount: number;
  public pediatricCancerActivityCount: number;
  public pediatricCancerNumberOfPeopleServed: number;
  public overallActivityCount: number;
  public overallNumberOfPeopleServed: number;
  public visionCountCampaignNumberOfPeopleServed: number;
  public hungerCountCampaignNumberOfPeopleServed: number;
  public environmentCountCampaignNumberOfPeopleServed: number;
  public diabetesCountCampaignNumberOfPeopleServed: number;
  public nonCampaignActivityCount: number;
  public nonCampaignNumberOfPeopleServed: number;
  public sumLionHours: number;
  public sumTotalMembership: number;
  public visionCountCampaignNumberOfPeopleServedPerMember: number;
  public hungerCountCampaignNumberOfPeopleServedPerMember: number;
  public environmentCountCampaignNumberOfPeopleServedPerMember: number;
  public diabetesCountCampaignNumberOfPeopleServedPerMember: number;
  public pediatricCancerNumberOfPeopleServedPerMember: number;
  public nonCampaignNumberOfPeopleServedPerMember: number;
  public overallNumberOfPeopleServedPerMember: number;
  public overallVolunteerHours: number;
  public diabetesVolunteerHours: number;
  public environmentVolunteerHours: number;
  public pediatricCancerVolunteerHours: number;
  public hungerVolunteerHours: number;
  public visionVolunteerHours: number;
  public nonCampaignVolunteerHours: number;
  public fundsDonated: number;
  constructor() {/**/}
}
